import styled from "styled-components";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import InfoIcon from "@mui/icons-material/Info";
import Modal from "@mui/material/Modal";

export const OkIcon = styled(CheckCircleRoundedIcon)`
  height: 10px !important;
  width: 10px !important;
  margin-right: 5px;
  color: var(--signed);
`;

export const WaitIcon = styled(InfoIcon)`
  height: 10px !important;
  width: 10px !important;

  color: var(--yellow);
  margin-right: 5px;
  //padding: 2px;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  //height: calc(100% - 70px);
  //height: 493px;
  height: max-content;
  min-width: 20vw;
  width: max-content;
`;

export const List = styled.div`
  max-height: 400px;
  overflow-x: scroll;
  border-radius: 5px;
  display: grid;
  gap: 5px;
  grid-template-columns:  repeat(auto-fit,minmax(400px, 1fr)) ;
  max-width: 900px;
  //grid-auto-flow: row;
   @media (max-width: 1000px) {
    max-width: 80vw;
    grid-template-columns: 1fr;
  }
`;

export const EmptyWrapper = styled.div`
  margin: auto;
  text-aline: center;
  svg {
    height: 100px;
    width: auto;
    margin: 0 auto;
    display: block;
    @media (max-width: 767px) {
      height: 72px;
    }
  }
`;

export const Block = styled.div`
  font-size: 12px;
  display: grid;
  grid:  max-content max-content/ max-content 125px max-content;
  gap: 5px 10px;
  align-items: left;
  color: var(--roman-silver);
  padding: 10px;
  background-color: var(--background-gray);
  border-radius: 5px;
  @media (max-width: 767px) {
    gap: 5px 8px;
    grid:  min-content min-content/ min-content minmax(50px, 125px) minmax(103px, 250px);
  }
  // @media (max-width: 440px) {
  //   gap: 5px 8px;
  //   grid:  min-content min-content/ min-content 65px minmax(40vw,50vw);
  // }

`;

export const Person = styled.div`
  color: black;
  line-height: 13px;
  text-wrap: wrap;
  overflow-wrap: break-word;
  max-width: 250px;
  @media (max-width: 767px) {
    width: 100%;
    max-width: 250px;
  }

`;

export const Details = styled.div`
  grid-column: 1;
  grid-row: span 3;
`;


export const CloseFullBtn = styled.button`
  color: var(--white);
  background-color: var(--red);
  height: 46px;
  width: 132px;
  margin: 0 auto;
  display: block;
  font-size: 14px;
  margin-top: 10px;
  @media (max-width: 767px) {
    width: 100%;
    height: 40px;
    font-size: 12px;

  }
`;

export const MainModal = styled(Modal)`
  & .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.7);
  }
  & .MuiBox-root {
    @media (max-width: 767px) {
      width: calc(100vw - 40px);
      max-width: 375px;
      padding: 40px 10px 10px 10px;
    }
  padding: 50px 20px 20px 20px;
  display: flex;
  justify-content: center;
  height: min-content;
    width: max-content;
    max-width: 900px;
    // height: ${(props) => (props.pub ? `max-content` : `min-content`)};
  }
`;
